import { ActivatedRouteSnapshot } from "@angular/router";
import { first } from "lodash";

export function setQueryStringParam(name: string, value: string): void {
  const url = new URL(window.location.href);
  url.searchParams.set(name, value);
  window.history.replaceState({}, document.title, url.toString());
}

export function removeQueryStringParam(name: string): void {
  const url = new URL(window.location.href);
  url.searchParams.delete(name);
  window.history.replaceState({}, document.title, url.toString());
}

export function isUrl(value: string): boolean {
  try {
    new URL(value);
    return true;
  } catch (e) {
    return false;
  }
}

export function getQueryParamsFromReturnUrl(snapshot: ActivatedRouteSnapshot): {
  invite: string;
  email: string;
  returnUrl: string;
} {
  const { returnUrl } = snapshot.queryParams;

  const returnUrlDecoded = decodeURIComponent(decodeURIComponent(returnUrl));

  const url = new URL(`${location.origin}${returnUrlDecoded}`);

  const invite = url.searchParams.get("invite") || "";
  const email = url.searchParams.get("email") || "";

  return {
    invite: invite,
    email: email,
    returnUrl: returnUrl
  };
}

export function getUrlWithoutQueryParams(url: string): string {
  return first(url.split("?"))!;
}
